import "./IssuesList.scss";

import IssuesList from "./IssuesList";

export default IssuesList;
